import React from "react";
import "./IssueMetaEditor.css";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import Dropzone from "react-dropzone";
import Moment from "moment";
import { toast } from "react-toastify";
import { updateIssueMetaApi } from "../../api/issues";

class IssueMetaEditor extends React.Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSelectCover = this.handleSelectCover.bind(this);
    this.handleEnterIssueName = this.handleEnterIssueName.bind(this);
    this.handleEnterPubuCategory = this.handleEnterPubuCategory.bind(this);
    this.handleEnterPubuID = this.handleEnterPubuID.bind(this);

    this.handleEnterAvailableFrom = this.handleEnterAvailableFrom.bind(this);
    this.handleEnterAvailableTo = this.handleEnterAvailableTo.bind(this);
    this.handleEnterOffShelfAt = this.handleEnterOffShelfAt.bind(this);
    this.handleEnterPublishAt = this.handleEnterPublishAt.bind(this);
    this.handleAdultContentChange = this.handleAdultContentChange.bind(this);
    this.handleLeftFlipChange = this.handleLeftFlipChange.bind(this);
    this.handleEnterYear = this.handleEnterYear.bind(this);

    this.handleEnterProductID = this.handleEnterProductID.bind(this);
    this.handleEnterContentsID = this.handleEnterContentsID.bind(this);

    const { issue } = this.props;

    const dateFormat = "YYYY-MM-DDTHH:mm:SS";
    const availableFrom =
      issue.available_from !== null && issue.available_from !== 0
        ? Moment(issue.available_from * 1000).format(dateFormat)
        : "";
    const availableTo =
      issue.available_to !== null && issue.available_to !== 2147483647
        ? Moment(issue.available_to * 1000).format(dateFormat)
        : "";
    const offShelfAt =
      issue.off_shelf_at !== null && issue.off_shelf_at !== 2147483647
        ? Moment(issue.off_shelf_at * 1000).format(dateFormat)
        : "";
    const publishAt =
      issue.published_at !== null
        ? Moment(issue.published_at * 1000).format(dateFormat)
        : "";

    this.state = {
      isLoading: false,
      uploadingCoverFile: null,

      issueName: issue.issue == null ? "" : issue.issue,
      pubuProductID: issue.pubu_product_id == null ? "" : issue.pubu_product_id,
      pubuProductCategory:
        issue.pubu_product_category == null ? "" : issue.pubu_product_category,

      productID: issue.product_id == null ? "" : issue.product_id,
      contentsID: issue.content_id == null ? "" : issue.content_id,

      availableFrom: availableFrom,
      availableTo: availableTo,
      offShelfAt: offShelfAt,
      publishAt: publishAt,

      isLeftFlip: issue.is_left_flip,
      isAdultContent: issue.is_adult == null ? false : issue.is_adult,
      year: issue.year == null ? "" : issue.year
    };
  }

  async handleSubmit(event) {
    event.preventDefault();
    event.stopPropagation();

    const { issue } = this.props;
    const form = event.currentTarget;

    if (form.checkValidity() === false) {
      return;
    }

    if (this.state.isLoading) {
      return;
    }

    this.setState({ isLoading: true });

    let metaData = {
      issueName: this.state.issueName,
      description: issue.description == null ? "" : issue.description,
      isAdult: this.state.isAdultContent,
      year: this.state.year,
      publishAt: this.state.publishAt,
      offShelfAt: this.state.offShelfAt,
      availableFrom: this.state.availableFrom,
      availableTo: this.state.availableTo,
      pubuProductID: this.state.pubuProductID,
      productID: this.state.productID,
      contentsID: this.state.contentsID,
      pubuProductCategory: this.state.pubuProductCategory,
      cover: this.state.uploadingCoverFile,
      isLeftFlip: this.state.isLeftFlip
    };

    const { isPdf, loadIssue } = this.props;

    try {
      await updateIssueMetaApi(issue.id, isPdf, metaData);
      loadIssue();
    } catch (e) {
      toast.error(e.toString());
    }

    this.setState({ isLoading: false, uploadingCoverFile: null });
    toast.success("Saved");
  }

  handleSelectCover(files) {
    if (this.state.isLoading) {
      return;
    }

    if (files.length < 1) {
      return;
    }

    const file = files[0];

    if (
      !file.name.toLowerCase().endsWith(".jpg") &&
      !file.name.toLowerCase().endsWith(".jpeg") &&
      !file.name.toLowerCase().endsWith(".png")
    ) {
      toast.error("Only jpg/png file is allowed");
      return;
    }

    this.setState({
      uploadingCoverFile: file
    });
  }

  handleEnterYear(event) {
    if (this.state.isLoading) {
      return;
    }

    this.setState({ year: event.target.value });
  }

  handleEnterIssueName(event) {
    if (this.state.isLoading) {
      return;
    }
    this.setState({ issueName: event.target.value });
  }

  handleEnterPubuID(event) {
    if (this.state.isLoading) {
      return;
    }
    this.setState({ pubuProductID: event.target.value });
  }

  handleEnterProductID(event) {
    if (this.state.isLoading) {
      return;
    }
    this.setState({ productID: event.target.value });
  }

  handleEnterContentsID(event) {
    if (this.state.isLoading) {
      return;
    }
    this.setState({ contentsID: event.target.value });
  }

  handleEnterPubuCategory(event) {
    if (this.state.isLoading) {
      return;
    }
    this.setState({ pubuProductCategory: event.target.value });
  }

  handleEnterAvailableFrom(event) {
    if (this.state.isLoading) {
      return;
    }
    this.setState({ availableFrom: event.target.value });
  }

  handleEnterAvailableTo(event) {
    if (this.state.isLoading) {
      return;
    }
    this.setState({ availableTo: event.target.value });
  }

  handleEnterOffShelfAt(event) {
    if (this.state.isLoading) {
      return;
    }
    this.setState({ offShelfAt: event.target.value });
  }

  handleEnterPublishAt(event) {
    if (this.state.isLoading) {
      return;
    }
    this.setState({ publishAt: event.target.value });
  }

  handleLeftFlipChange(event) {
    if (this.state.isLoading) {
      return;
    }
    this.setState({ isLeftFlip: event.target.checked });
  }

  handleAdultContentChange(event) {
    if (this.state.isLoading) {
      return;
    }
    this.setState({ isAdultContent: event.target.checked });
  }

  render() {
    const {
      issueName,
      pubuProductID,
      pubuProductCategory,
      productID,
      contentsID,
      isLoading,
      uploadingCoverFile,
      availableFrom,
      availableTo,
      publishAt,
      offShelfAt,
      isLeftFlip,
      isAdultContent,
      year
    } = this.state;

    return (
      <Form className="issue_meta_form" onSubmit={e => this.handleSubmit(e)}>
        <Form.Row>
          <Form.Group as={Col} sm="12" md="12" controlId="issueName">
            <Form.Label>Issue</Form.Label>
            <Form.Control
              required
              type="text"
              placeholder="Issue"
              value={issueName}
              onChange={this.handleEnterIssueName}
            />
          </Form.Group>
        </Form.Row>
        <Form.Row>
          {this.props.isPdf && (
            <Form.Group as={Col} sm="12" md="4" controlId="pubuProductID">
              <Form.Label>
                {process.env.REACT_APP_REGION === "JP"
                  ? "Product ID"
                  : "Pubu Product ID"}
              </Form.Label>
              <Form.Control
                type="text"
                placeholder={
                  process.env.REACT_APP_REGION === "JP"
                    ? "Product ID"
                    : "Pubu Product ID"
                }
                value={
                  process.env.REACT_APP_REGION === "JP"
                    ? productID
                    : pubuProductID
                }
                onChange={
                  process.env.REACT_APP_REGION === "JP"
                    ? this.handleEnterProductID
                    : this.handleEnterPubuID
                }
              />
            </Form.Group>
          )}

          {this.props.isPdf && (
            <Form.Group as={Col} sm="12" md="4" controlId="pubuProductCategory">
              <Form.Label>
                {process.env.REACT_APP_REGION === "JP"
                  ? "Contents ID"
                  : "Pubu Category"}
              </Form.Label>
              <InputGroup>
                <Form.Control
                  type="text"
                  placeholder={
                    process.env.REACT_APP_REGION === "JP"
                      ? "Contents ID"
                      : "Pubu Product Category"
                  }
                  value={
                    process.env.REACT_APP_REGION === "JP"
                      ? contentsID
                      : pubuProductCategory
                  }
                  onChange={
                    process.env.REACT_APP_REGION === "JP"
                      ? this.handleEnterContentsID
                      : this.handleEnterPubuCategory
                  }
                />
              </InputGroup>
            </Form.Group>
          )}

          <Form.Group as={Col} sm="12" md="4" controlId="year">
            <Form.Label>Year</Form.Label>
            <Form.Control
              type="text"
              placeholder="year"
              value={year}
              onChange={this.handleEnterYear}
            />
          </Form.Group>
        </Form.Row>
        <Form.Row>
          <Form.Group as={Col} sm="12" md="6" controlId="publishTime">
            <Form.Label>Publish at</Form.Label>
            <Form.Control
              type="datetime-local"
              min="1970-01-01T00:00:00"
              max="2038-01-19T11:14:07"
              step="1"
              value={publishAt}
              onChange={this.handleEnterPublishAt}
            />
          </Form.Group>
          <Form.Group as={Col} sm="12" md="6" controlId="offTime">
            <Form.Label>Off shelf at</Form.Label>
            <Form.Control
              type="datetime-local"
              min="1970-01-01T00:00:00"
              max="2038-01-19T11:14:07"
              step="1"
              value={offShelfAt}
              onChange={this.handleEnterOffShelfAt}
            />
          </Form.Group>
        </Form.Row>
        <Form.Row>
          <Form.Group as={Col} sm="12" md="6" controlId="availableStartTime">
            <Form.Label>Available from</Form.Label>
            <Form.Control
              type="datetime-local"
              min="1970-01-01T00:00:00"
              max="2038-01-19T11:14:07"
              step="1"
              value={availableFrom}
              onChange={this.handleEnterAvailableFrom}
            />
          </Form.Group>
          <Form.Group as={Col} sm="12" md="6" controlId="availableEndTime">
            <Form.Label>Available to</Form.Label>
            <Form.Control
              type="datetime-local"
              min="1970-01-01T00:00:00"
              max="2038-01-19T11:14:07"
              step="1"
              value={availableTo}
              onChange={this.handleEnterAvailableTo}
            />
          </Form.Group>
        </Form.Row>
        <Form.Row>
          <Col sm="12">
            <Dropzone disabled={isLoading} onDrop={this.handleSelectCover}>
              {({ getRootProps, getInputProps }) => (
                <div
                  className={
                    uploadingCoverFile == null
                      ? "upload_zone"
                      : "upload_zone_green"
                  }
                  {...getRootProps()}
                >
                  <input {...getInputProps()} />
                  <span>
                    {uploadingCoverFile == null
                      ? "Drop/Click for cover image file"
                      : uploadingCoverFile.name}
                  </span>
                </div>
              )}
            </Dropzone>
          </Col>
        </Form.Row>
        <Form.Row className="issue_meta_btm_row">
          <Col className="issue_meta_check_col" sm="12" md="6">
            {this.props.isPdf && (
              <Form.Check
                id="left_flip_checkbox"
                custom
                inline
                label="Left Flip"
                type="checkbox"
                checked={isLeftFlip == null ? false : isLeftFlip}
                onChange={this.handleLeftFlipChange}
              />
            )}
            <Form.Check
              id="adult_content_checkbox"
              custom
              inline
              label="Adult Content"
              type="checkbox"
              checked={isAdultContent}
              onChange={this.handleAdultContentChange}
            />
          </Col>
          <Col className="issue_meta_btn_col" sm="12" md="6">
            <Button
              disabled={isLoading}
              className="issue_meta_save_btn"
              variant="info"
              type="submit"
            >
              {isLoading ? (
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              ) : (
                "Save"
              )}
            </Button>
          </Col>
        </Form.Row>
      </Form>
    );
  }
}

export default IssueMetaEditor;
